module.exports = __webpack_public_path__ + "static/media/remote3.0b2c2e98.jpg";